module.exports = __webpack_public_path__ + "assets/img/kv-3639c1e3.jpg";